import { t } from "@/i18n-js/instance";
import { RSVP_STATUS } from "@circle-react/components/Events/helpers/constants";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circle-react-uikit/Button";
import { CheckIcon } from "./RsvpIcons";

interface RsvpButtonProps {
  declineInvite: () => void;
  detailsPage?: boolean;
  full: boolean;
  isConfirmed: boolean;
  isLoading: boolean;
  isRsvpDisabled?: boolean;
  paidEvent: boolean;
  rsvpStatus: "yes" | "no" | "invited";
  toggleRsvp: () => void;
  variant?: "primary" | "secondary";
}

export const RsvpButton = ({
  isConfirmed,
  full,
  toggleRsvp,
  declineInvite,
  rsvpStatus,
  isLoading,
  paidEvent,
  variant = "primary",
  isRsvpDisabled = false,
  detailsPage = false,
}: RsvpButtonProps) => {
  const isAttendeeInvited = rsvpStatus === RSVP_STATUS.INVITED;
  return (
    <>
      {isAttendeeInvited && (
        <div
          className={classNames("flex gap-x-2 gap-y-3", {
            "flex-wrap": detailsPage,
          })}
        >
          <Button
            variant="primary"
            full={full}
            onClick={toggleRsvp}
            disabled={isLoading}
            className="min-w-fit whitespace-nowrap !rounded-full !font-semibold"
          >
            {t("events.rsvp.invite.accept")}
          </Button>
          <Button
            variant="secondary"
            full={full}
            onClick={declineInvite}
            disabled={isLoading}
            className={classNames("!ml-0 !rounded-full !font-semibold", {
              "!border-primary": variant === "secondary",
            })}
          >
            {t("events.rsvp.invite.decline")}
          </Button>
        </div>
      )}
      {!isConfirmed && !isAttendeeInvited && (
        <Button
          variant={variant}
          full={full}
          onClick={toggleRsvp}
          disabled={isLoading || isRsvpDisabled}
          className={classNames("!font-semibold", {
            "!border-primary": variant === "secondary",
          })}
        >
          {paidEvent ? t("events.rsvp.buy_ticket") : t("events.rsvp.rsvp")}
        </Button>
      )}
      {isConfirmed && <CheckIcon />}
    </>
  );
};
